<template>
  <div class="form-group">
    <label :for="id">{{ label }}</label>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        :id="id"
        :placeholder="placeholder"
        v-bind:value="value"
        @invalid="expandContent($refs.collapseLink, $refs.collapseElement)"
        @blur="validateRequired"
        v-on:input="$emit('input', $event.target.value)"
        :required="isRequired"
        v-on:focus="$emit('focus')"
      />

      <div v-if="appendText" class="input-group-append">
        <span class="input-group-text">{{ appendText }}</span>
      </div>
      <div class="invalid-feedback">
        <span>{{ $t("form.shared.validation_error") }}</span>
      </div>
    </div>
    <small v-if="hint">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  props: {
    // Id for input field and used in for directive for label
    id: {
      type: String,
      required: true,
    },
    // Text to be shown above inputfield
    label: {
      type: String,
      required: true,
    },
    // Text to be show as placeholder in input element
    placeholder: {
      type: String,
      required: false,
    },
    // What value to bind to, through the v-mode directive
    value: {
      type: String,
      required: true,
    },
    // Boolean to tell if input field is required or not
    isRequired: {
      type: Boolean,
    },
    // Text to be appended to the right of input field
    appendText: {
      type: String,
      required: false,
    },
    // Text to show below input field
    hint: {
      type: String,
      required: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/shared/components/Textfield.vue